import React, { FC } from "react";
import classes from "./style/LegalEntities.module.css";
import { LegalEntityCard } from "./LegalEntityCard/LegalEntityCard";
import { useAppSelector } from "../../../../../store/reduxHooks";
import { SELECT_APPLICATIONS_DATA_TO_BANK_MEMBER_UL } from "../../../../../store/selectors/applicationDataToBankSelector";

export const LegalEntities: FC = () => {
  const data = useAppSelector(SELECT_APPLICATIONS_DATA_TO_BANK_MEMBER_UL);

  return (
    <div className={classes.legalEntitiesWrapper}>
      {data?.map((individual) => {
        const { inn, id, shortname, percent } = individual;

        return (
          <LegalEntityCard
            key={id}
            inn={inn}
            name={shortname}
            percent={percent}
          />
        );
      })}
    </div>
  );
};
